<template>
  <div class="position-relative">
    <div v-if="!sensorActive">
      <b-row class="mb-1">
        <b-col cols="12" lg="6" class="form-group">
          <div class="demo-vertical-spacing search-form-inputs">
            <!-- basic search -->
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input type="number" ref="firstDigit" @keyup.delete="sensorActive ? '' : setFocusPrev('firstDigit')" @input="setFocusNext('secondDigit', $event), sensorActive ? backspase('firstDigit', $event) : ''" :formatter="formatLength" v-model="firstDigit" autocomplete="off"  data-layout="numeric" @focus="showKeyboard"/>
              <b-form-input type="number" ref="secondDigit" @keyup.delete="sensorActive ? '' : setFocusPrev('firstDigit')" @input="setFocusNext('thirdDigit', $event), sensorActive ? backspase('firstDigit', $event) : ''" :formatter="formatLength" v-model="secondDigit" autocomplete="off"  data-layout="numeric" @focus="showKeyboard"/>
              <b-form-input type="number" ref="thirdDigit" @keyup.delete="sensorActive ? '' : setFocusPrev('secondDigit')" @input="setFocusNext('fourthDigit', $event), sensorActive ? backspase('secondDigit', $event) : ''" :formatter="formatLength" v-model="thirdDigit" autocomplete="off"  data-layout="numeric" @focus="showKeyboard"/>
              <b-form-input type="number" ref="fourthDigit" @keyup.delete="sensorActive ? '' :  setFocusPrev('thirdDigit')" @input="setFocusNext('fifthDigit', $event), sensorActive ? backspase('thirdDigit', $event) : ''" :formatter="formatLength" v-model="fourthDigit" autocomplete="off"  data-layout="numeric" @focus="showKeyboard"/>
              <b-form-input type="number" ref="fifthDigit" @keyup.delete="sensorActive ? '' :  setFocusPrev('fourthDigit')" @input="setFocusNext('sixthDigit', $event), sensorActive ? backspase('fourthDigit', $event) : ''" :formatter="formatLength" v-model="fifthDigit" autocomplete="off"  data-layout="numeric" @focus="showKeyboard"/>
              <b-form-input type="number" ref="sixthDigit" @keyup.delete="sensorActive ? '' :  setFocusPrev('fifthDigit')" @input="setFocusNext('seventhDigit', $event), sensorActive ? backspase('fifthDigit', $event) : ''" :formatter="formatLength" v-model="sixthDigit" autocomplete="off"  data-layout="numeric" @focus="showKeyboard"/>
              <b-form-input type="number" ref="seventhDigit" @keyup.delete="sensorActive ? '' :  setFocusPrev('sixthDigit')" @input="setFocusNext('eighthDigit', $event), sensorActive ? backspase('sixthDigit', $event) : ''" :formatter="formatLength" v-model="seventhDigit" autocomplete="off"  data-layout="numeric" @focus="showKeyboard"/>
              <b-form-input type="number" ref="eighthDigit" @keyup.delete="sensorActive ? '' :  setFocusPrev('seventhDigit')" @input="setFocusNext('ninethDigit', $event), sensorActive ? backspase('seventhDigit', $event) : ''" :formatter="formatLength" v-model="eighthDigit" autocomplete="off"  data-layout="numeric" @focus="showKeyboard"/>
              <b-form-input type="number" ref="ninethDigit" @keyup.delete="sensorActive ? '' :  setFocusPrev('eighthDigit')" :formatter="formatLength" v-model="ninethDigit" @input="setFocusNext('ninethDigit', $event), sensorActive ? backspase('eighthDigit', $event) : ''" autocomplete="off"  data-layout="numeric" @focus="showKeyboard"/>
              <b-input-group-append is-text @click="clearMSISDN">
                <feather-icon icon="XIcon" />
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col>
        <b-col cols="12" lg="6" class="form-group">
          <v-select
            v-model="selected3"
            :dir="dir"
            multiple
            label="title"
            :options="levels" @input="selectLevels"
          />
        </b-col>
      </b-row>
      <b-overlay
        :show="show"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="lg"
        variant="white"
        opacity="0.85"
        blur="2px"
      >
        <b-row class="mb-1" >
          <Number @modalOrder="modalOrder" :custom-class="'col-6 col-md-4 col-lg-4 col-xl-3 '"
                  :ref="`${numberKeys[(perPage*(currentPage-1))+(n-1)]}`"
                  :msisdn="`${numberKeys[(perPage*(currentPage-1))+(n-1)]}`"
                  :price="numbers[numberKeys[(perPage*(currentPage-1))+(n-1)]].level_price"
                  :category="numbers[numberKeys[(perPage*(currentPage-1))+(n-1)]].level_name"
                  v-for="n in rows > 0 ? ((rows % perPage > 0) && (currentPage > parseInt(rows/perPage)) ? rows % perPage : perPage) : 0"
                  :key="n" :data="n"
                  data-layout="numeric"></Number>
        </b-row>
      </b-overlay>
      <b-row v-show="rows>0">
        <div class="demo-spacing-0 d-flex justify-content-center w-100">
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-row>
    </div>
    <div  v-if="sensorActive" class="sensorActive">
      <b-row class="mb-1">
        <b-col cols="12" lg="4" class="form-group position-absolute category">
          <v-select
            v-model="selected3"
            :dir="dir"
            label="title"
            :options="levels" @input="selectLevels"
          />
        </b-col>
        <b-col cols="12" lg="12" class="form-group">
          <div class="demo-vertical-spacing search-form-inputs">
            <!-- basic search -->
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon class="font-large-2 text-primary" icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input type="text" placeholder="-"  ref="firstDigit" @keyup.delete="sensorActive ? '' : setFocusPrev('firstDigit')" @input="setFocusNext('secondDigit', $event), sensorActive ? backspase('firstDigit', $event) : ''" :formatter="formatLength" v-model.trim="firstDigit" autocomplete="off"  data-layout="numeric" @focus="showKeyboardCustom"/>
              <b-form-input type="text" placeholder="-"  ref="secondDigit" @keyup.delete="sensorActive ? '' : setFocusPrev('firstDigit')" @input="setFocusNext('thirdDigit', $event), sensorActive ? backspase('firstDigit', $event) : ''" :formatter="formatLength" v-model.trim="secondDigit" autocomplete="off"  data-layout="numeric" @focus="showKeyboardCustom"/>
              <b-form-input type="text" placeholder="-" ref="thirdDigit" @keyup.delete="sensorActive ? '' : setFocusPrev('secondDigit')" @input="setFocusNext('fourthDigit', $event), sensorActive ? backspase('secondDigit', $event) : ''" :formatter="formatLength" v-model.trim="thirdDigit" autocomplete="off"  data-layout="numeric" @focus="showKeyboardCustom"/>
              <b-form-input type="text" placeholder="-" ref="fourthDigit" @keyup.delete="sensorActive ? '' :  setFocusPrev('thirdDigit')" @input="setFocusNext('fifthDigit', $event), sensorActive ? backspase('thirdDigit', $event) : ''" :formatter="formatLength" v-model.trim="fourthDigit" autocomplete="off"  data-layout="numeric" @focus="showKeyboardCustom"/>
              <b-form-input type="text" placeholder="-" ref="fifthDigit" @keyup.delete="sensorActive ? '' :  setFocusPrev('fourthDigit')" @input="setFocusNext('sixthDigit', $event), sensorActive ? backspase('fourthDigit', $event) : ''" :formatter="formatLength" v-model.trim="fifthDigit" autocomplete="off"  data-layout="numeric" @focus="showKeyboardCustom"/>
              <b-form-input type="text" placeholder="Х" ref="sixthDigit" @keyup.delete="sensorActive ? '' :  setFocusPrev('fifthDigit')" @input="setFocusNext('seventhDigit', $event), sensorActive ? backspase('fifthDigit', $event) : ''" :formatter="formatLength" v-model.trim="sixthDigit" autocomplete="off"  data-layout="numeric" @focus="showKeyboardCustom"/>
              <b-form-input type="text" placeholder="Х" ref="seventhDigit" @keyup.delete="sensorActive ? '' :  setFocusPrev('sixthDigit')" @input="setFocusNext('eighthDigit', $event), sensorActive ? backspase('sixthDigit', $event) : ''" :formatter="formatLength" v-model.trim="seventhDigit" autocomplete="off"  data-layout="numeric" @focus="showKeyboardCustom"/>
              <b-form-input type="text" placeholder="Х" ref="eighthDigit" @keyup.delete="sensorActive ? '' :  setFocusPrev('seventhDigit')" @input="setFocusNext('ninethDigit', $event), sensorActive ? backspase('seventhDigit', $event) : ''" :formatter="formatLength" v-model.trim="eighthDigit" autocomplete="off"  data-layout="numeric" @focus="showKeyboardCustom"/>
              <b-form-input type="text" placeholder="Х" ref="ninethDigit" @keyup.delete="sensorActive ? '' :  setFocusPrev('eighthDigit')" :formatter="formatLength" v-model.trim="ninethDigit" @input="setFocusNext('ninethDigit', $event, 'ninethDigit'), sensorActive ? backspase('eighthDigit', $event) : ''" autocomplete="off"  data-layout="numeric" @focus="showKeyboardCustom"/>
              <b-input-group-append is-text @click="clearMSISDN">
                <feather-icon class="font-large-2 text-primary" icon="XIcon" />
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col>
      </b-row>
      <b-row class="">
        <b-col cols="12" lg="8" class="overflow-hidden oscroll py-1">
          <b-overlay
            :show="show"
            spinner-variant="primary"
            spinner-type="grow"
            spinner-small
            rounded="lg"
            variant="white"
            opacity="0.85"
            blur="2px"
          >
            <b-row class="mb-1" >
              <Number @modalOrder="modalOrder" :custom-class="'col-4'"
                      :ref="`${numberKeys[(perPage*(currentPage-1))+(n-1)]}`"
                      :msisdn="`${numberKeys[(perPage*(currentPage-1))+(n-1)]}`"
                      :price="numbers[numberKeys[(perPage*(currentPage-1))+(n-1)]].level_price"
                      :category="numbers[numberKeys[(perPage*(currentPage-1))+(n-1)]].level_name"
                      v-for="n in rows > 0 ? ((rows % perPage > 0) && (currentPage > parseInt(rows/perPage)) ? rows % perPage : perPage) : 0"
                      :key="n" :data="n"
                      data-layout="numeric"></Number>
            </b-row>
            </b-overlay>
        </b-col>
        <b-col cols="4" class="mt-1" lg="4">
          <vue-touch-keyboard-custom :options="options" v-if="visible" :layout="layout" :cancel="keyboardHideCustom" :accept="accept"
                                     :input="input"/>
          <div v-if="sensorActive" class="d-block mt-2">
            <router-link to="/packages">
              <div class="card bg-yellow text-center text-primary animation mb-0">
                <div class="d-flex align-items-center justify-content-center p-2">
          <span class="b-avatar text-danger" style="width: 45px; height: 45px;">
            <span class=" ">
                 <feather-icon icon="ShoppingBagIcon" class="mr-2" size="45"/>
            </span>
          </span>
                  <span><h3 class="text-danger font-large-1 font-weight-bolder m-0">Мобипакеты</h3></span>
                </div>
              </div>
            </router-link>
          </div>
        </b-col>
      </b-row>
    </div>

    <OrderNumbers ref="orderModal"  @keyboard-open="showKeyboard" @keyboard-hide="keyboardHide" @close-modal="closeModalOrder"/>
  </div>
</template>

<script>
import Number from '@/views/frontend/components/numbers/components/Number.vue'
import OrderNumbers from '@/views/frontend/components/OrderNumber.vue'
import {
  BOverlay,
  BRow,
  BCol,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  BInputGroupAppend,
  BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import axios from 'axios'
import '@/@core/components/app-keyboard/vue-touch-keyboard-custom/dist/vue-touch-keyboard.css' // load default style

export default {
  name: 'SearchForm',
  components: {
    BOverlay,
    BRow,
    BCol,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    BInputGroupAppend,
    BPagination,
    vSelect,
    Number,
    OrderNumbers,
  },
  data() {
    return {
      show: false,
      dir: 'ltr',
      firstDigit: '',
      secondDigit: null,
      thirdDigit: null,
      fourthDigit: null,
      fifthDigit: null,
      sixthDigit: null,
      seventhDigit: null,
      eighthDigit: null,
      ninethDigit: null,
      numbers: [],
      numberKeys: [],
      selected3: null,
      levels: [],
      requestServer: null,
      requests: [],
      request: null,
      currentPage: 1,
      perPage: 12,
      rows: 0,
      url: '',
      statusModal: false,
      sensorActive: false,
      visible: false,
      layout: 'numeric',
      input: null,
      options: {
        useKbEvents: false,
      },
    }
  },
  methods: {
    modalOrder(msisdn, category, price) {
      this.$refs.orderModal.showModal(msisdn, category, price)
    },
    closeModalOrder(statusRefresh = false) {
      if (statusRefresh) {
        this.refreshSearch()
      }
    },
    readItemsMenu() {
      const that = this
      that.$http.get(`${this.url}/api/levels`, {})
        .then(response => {
          that.levels = response.data
          if (that.levels.length > 0) {
            that.selected3 = [
              that.levels[0],
            ]
          }
        }).catch()
    },
    backspase(refInput, val) {
      if (val === '') {
        this.setFocusPrev(refInput)
      }
    },
    setFocusPrev(refInput) {
      this.$refs[refInput].focus()
      this.$refs[refInput].select()
    },
    setFocusNext(refInput, val, currentInput = '') {
      if (val === ' ' || (val !== '' && val >= 0 && val <= 9)) {
        this.$refs[refInput].focus()
        this.$refs[refInput].select()
        if (val === ' ') {
          switch (refInput) {
            case 'secondDigit':
              this.firstdDigit = null
              break
            case 'thirdDigit':
              this.secondDigit = null
              break
            case 'fourthDigit':
              this.thirdDigit = null
              break
            case 'fifthDigit':
              this.fourthDigit = null
              break
            case 'sixthDigit':
              this.fifthDigit = null
              break
            case 'seventhDigit':
              this.sixthDigit = null
              break
            case 'eighthDigit':
              this.seventhDigit = null
              break
            default:
              break
          }
          if (val === ' ' && refInput === 'ninethDigit' && currentInput === '') {
            this.eighthDigit = null
          }
          if (val === ' ' && refInput === currentInput) {
            this.ninethDigit = null
          }
        }
      }
      if ((val === '' || val === null) && refInput === currentInput) {
        this.ninethDigit = null
      }
      const that = this
      let msisdn = ''
      if (that.firstDigit === '' || that.firstDigit === null) {
        msisdn += '_'
      } else {
        msisdn += that.firstDigit
      }
      if (that.secondDigit === '' || that.secondDigit === null) {
        msisdn += '_'
      } else {
        msisdn += that.secondDigit
      }
      if (that.thirdDigit === '' || that.thirdDigit === null) {
        msisdn += '_'
      } else {
        msisdn += that.thirdDigit
      }
      if (that.fourthDigit === '' || that.fourthDigit === null) {
        msisdn += '_'
      } else {
        msisdn += that.fourthDigit
      }
      if (that.fifthDigit === '' || that.fifthDigit === null) {
        msisdn += '_'
      } else {
        msisdn += that.fifthDigit
      }
      if (that.sixthDigit === '' || that.sixthDigit === null) {
        msisdn += '_'
      } else {
        msisdn += that.sixthDigit
      }
      if (that.seventhDigit === '' || that.seventhDigit === null) {
        msisdn += '_'
      } else {
        msisdn += that.seventhDigit
      }
      if (that.eighthDigit === '' || that.eighthDigit === null) {
        msisdn += '_'
      } else {
        msisdn += that.eighthDigit
      }
      if (that.ninethDigit === '' || that.ninethDigit === null) {
        msisdn += '_'
      } else {
        msisdn += that.ninethDigit
      }
      // axios.get(`http://192.168.1.4/api/free-numbers/msisdns?likeMsisdn=${msisdn}&category=`,
      //   { cancelToken: that.requestServer.token })
      //   .then(response => {
      //     that.numbers = response.data
      //   }).catch()
      let levels = ''
      if (this.sensorActive) {
        if (this.selected3.value) {
          levels = this.selected3.value
        } else {
          levels = '0'
        }
      } else {
        this.selected3.forEach((value, key) => {
          if (key !== 0) {
            levels += '|'
          }
          levels += value.value
        })
      }

      this.send(`${this.url}/api/free-numbers/msisdns?likeMsisdn=${msisdn}&category=${levels}`)
    },
    refreshSearch() {
      const that = this
      let msisdn = ''
      if (that.firstDigit === '') {
        msisdn += '_'
      } else {
        msisdn += that.firstDigit
      }
      if (that.secondDigit === '') {
        msisdn += '_'
      } else {
        msisdn += that.secondDigit
      }
      if (that.thirdDigit === '') {
        msisdn += '_'
      } else {
        msisdn += that.thirdDigit
      }
      if (that.fourthDigit === '') {
        msisdn += '_'
      } else {
        msisdn += that.fourthDigit
      }
      if (that.fifthDigit === '') {
        msisdn += '_'
      } else {
        msisdn += that.fifthDigit
      }
      if (that.sixthDigit === '') {
        msisdn += '_'
      } else {
        msisdn += that.sixthDigit
      }
      if (that.seventhDigit === '') {
        msisdn += '_'
      } else {
        msisdn += that.seventhDigit
      }
      if (that.eighthDigit === '') {
        msisdn += '_'
      } else {
        msisdn += that.eighthDigit
      }
      if (that.ninethDigit === '' || that.ninethDigit === null) {
        msisdn += '_'
      } else {
        msisdn += that.ninethDigit
      }
      let levels = ''
      if (this.sensorActive) {
        if (this.selected3.value) {
          levels = this.selected3.value
        } else {
          levels = this.selected3[0].value
        }
      } else {
        this.selected3.forEach((value, key) => {
          if (key !== 0) {
            levels += '|'
          }
          levels += value.value
        })
      }

      this.send(`${this.url}/api/free-numbers/msisdns?likeMsisdn=${msisdn}&category=${levels}`)
    },
    stopAll() {
      this.requestServer = axios.CancelToken.source()
      if (this.requestServer) {
        this.requestServer.cancel('cancel')
      }
    },
    formatLength(e) {
      return String(e).substring(0, 1)
    },
    send(API_URL) {
      if (this.request) this.cancel()
      this.makeRequest(API_URL)
    },
    cancel() {
      this.request.cancel()
      this.clearOldRequest('Cancelled')
    },
    makeRequest(API_URL) {
      this.show = true
      const axiosSource = axios.CancelToken.source()
      this.request = { cancel: axiosSource.cancel, msg: 'Loading...' }
      const that = this
      axios
        .get(API_URL, { cancelToken: axiosSource.token })
        .then(response => {
          this.clearOldRequest('Success')
          that.numbers = response.data.infoNumbers
          that.numberKeys = response.data.keys
          that.rows = that.numberKeys.length
          if (that.sensorActive) {
            that.perPage = that.rows
          }
          that.currentPage = 1
          that.show = false
        })
        .catch(this.logResponseErrors)
    },
    logResponseErrors(err) {
      if (axios.isCancel(err)) {
        console.log('Request cancelled')
      }
      // this.numbers = {}
      // this.numberKeys = []
      // this.rows = 0
      // this.currentPage = 1
    },
    clearOldRequest(msg) {
      this.request.msg = msg
      this.requests.push(this.request)
      this.request = null
      this.show = false
    },
    selectLevels() {
      this.setFocusNext('', '')
      if (this.selected3.length > 0 && this.selected3[this.selected3.length - 1].value === '0') {
        this.selected3 = [{
          title: 'Все категории',
          icon: 'DatabaseIcon',
          value: '0',
        }]
      }
    },
    clearMSISDN() {
      this.firstDigit = ''
      this.secondDigit = ''
      this.thirdDigit = ''
      this.fourthDigit = ''
      this.fifthDigit = ''
      this.sixthDigit = ''
      this.seventhDigit = ''
      this.eighthDigit = ''
      this.ninethDigit = ''
      this.$refs.firstDigit.select()
      this.send(`${this.url}/api/free-numbers/msisdns?likeMsisdn=&category=0`)
    },
    showKeyboard(e) {
      this.$emit('input-focus', e)
    },
    keyboardHide() {
      this.$emit('keyboard-hide')
    },
    showKeyboardCustom(e) {
      if (this.sensorActive) {
        if (e) {
          this.input = e.target
          this.layout = e.target.dataset.layout
        }

        if (!this.visible) {
          this.visible = true
        }
      } else {
        this.visible = false
      }
    },
    keyboardHideCustom() {
      this.visible = false
    },
    accept() {
      this.keyboardHideCustom()
    },
  },
  created() {
    if (this.$route.query.sensor && this.$route.query.sensor === 'active') {
      this.sensorActive = true
      this.selected3 = 0
    } else {
      this.sensorActive = false
      this.selected3 = []
    }

    const width = window.outerWidth
    if (width > 1366 && width <= 1600) {
      this.perPage = 16
    } else if (width > 1600) {
      this.perPage = 24
    }
    // const url = window.location.href
    // const arr = url.split('//')
    // const domain = arr[1].split(':')
    this.url = 'https://tojtel.tj'
    this.readItemsMenu()
    this.send(`${this.url}/api/free-numbers/msisdns?likeMsisdn=&category=0`)
  },
  updated() {
    if (this.sensorActive && !this.visible) {
      this.visible = true
    }
    if (this.sensorActive && !this.input) {
      this.input = this.$refs.firstDigit.$el
    }
  },
}
</script>

<style scoped>
.form-control[readonly] {
  background-color: #ffffff;
}
.sensorActive .form-control {
  font-size: 60px;
  height: 70px;
  color: #2d2e9b;
  font-width: bold;
}

.search-form-inputs input{
  text-align: center;
  border-left: 1px solid #d8d6de !important;
  border-right: 1px solid #d8d6de !important;
  font-weight: bold;
}
.sensorActive .search-form-inputs input, .sensorActive .input-group-text {
  border: 2px solid #2d2e9b !important;
}

.sensorActive .oscroll{
  height: calc(100vh - 215px);
  overflow-y: scroll !important;
}
.bg-yellow .text-danger{
  color: #F10001 !important;
}
.bg-yellow{
  background-color:  #fff700 !important;
}
.sensorActive .card{
  border-radius: 0.428rem !important;
}
.sensorActive .category{
  top: -57px;
  right: -14px;
}

</style>
